import { render, staticRenderFns } from "./selectedBoxMatchMacking.vue?vue&type=template&id=3603a914&scoped=true"
import script from "./selectedBoxMatchMacking.vue?vue&type=script&lang=js"
export * from "./selectedBoxMatchMacking.vue?vue&type=script&lang=js"
import style0 from "./selectedBoxMatchMacking.vue?vue&type=style&index=0&id=3603a914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603a914",
  null
  
)

export default component.exports